import { render, staticRenderFns } from "./backdrop.vue?vue&type=template&id=0013438f&scoped=true&"
import script from "./backdrop.vue?vue&type=script&lang=js&"
export * from "./backdrop.vue?vue&type=script&lang=js&"
import style0 from "./backdrop.vue?vue&type=style&index=0&id=0013438f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013438f",
  null
  
)

export default component.exports